// Anmeldung mit Rückweg (Frage 62, Daniel, 04.10.2026).
//
// Wer ohne Sitzung eine Seite im Mitgliederbereich öffnet (Lektionslink aus
// einer Mail, Lesezeichen, QR-Code), landet auf /login. Bis 04.10.2026 ging
// das Ziel dabei verloren und man stand nach dem Anmelden auf der Übersicht.
// Login.tsx liest `?redirect=` schon und springt nach dem Anmelden dorthin.

/**
 * `/login?redirect=<pfad>` für einen Pfad innerhalb der Seite, sonst `/login`.
 * Nur Pfade mit genau einem führenden Schrägstrich („//fremd.de“ wäre eine
 * fremde Seite) und nicht die Anmeldung selbst.
 */
export function loginMitRueckweg(pfad: string | null | undefined): string {
  const ziel = String(pfad ?? "");
  if (!ziel.startsWith("/") || ziel.startsWith("//") || ziel === "/" || ziel.startsWith("/login")) return "/login";
  return `/login?redirect=${encodeURIComponent(ziel)}`;
}

/** Der Rückweg zur Seite, auf der man gerade steht (Pfad, Suche, Anker). */
export function loginMitRueckwegHierher(): string {
  const { pathname, search, hash } = window.location;
  return loginMitRueckweg(`${pathname}${search}${hash}`);
}
